import React from "react";
import { FileUpload, BarChart, PieChart } from "@mui/icons-material";

export const ribMenus = [
  {
    label: "Import Data",
    icon: <FileUpload />,
    children: [
      { label: "Bank (Cr) Data", icon: <BarChart /> },
      { label: "CRIS (Dr) Data", icon: <PieChart /> },
    ],
  },
  {
    label: "Export Data",
    icon: <FileUpload />,
    children: [
      { label: "Bank Prepared CSV", icon: <BarChart /> },
      { label: "Unmatched Data", icon: <PieChart /> },
    ],
  },
  { label: "Search Data", icon: <BarChart /> },
  {
    label: "Reports",divider: true,
    icon: <PieChart />,
    children: [
      { label: "Credit Data", icon: <PieChart /> },
      { label: "Debit Data", icon: <BarChart /> },
      { label: "Matched Data", icon: <BarChart /> },
      { label: "Monthly Progressive Report", icon: <PieChart /> },
    ],
  },
];
